import { http } from "../api/http";
import config from "../environments/config";
import Utils from "../utils";

export const userService = {
  login,
  validateMfaCode,
  oktaLogin,
  azureAdLogin,
  recoverPassword,
  validateCode,
  updatePassword,
  create,
  get,
  getById,
  update,
  remove,
  impersonate,
  stopImpersonation,
  refreshCurrentUser,
  getMcpRedirectUrl,
};

function login(email, password) {
  let url = `/user/login`;

  return http
    .post(
      url,
      JSON.stringify({
        email,
        password,
      })
    )
    .then((response) => {
      return response;
    });
}

function validateMfaCode(email, code, keepMeSignedIn) {
  let url = `/user/validatemfacode`;

  return http
    .post(
      url,
      JSON.stringify({
        email,
        code,
        keepMeSignedIn,
      })
    )
    .then((response) => {
      return response;
    });
}

async function oktaLogin(requestBody, oktaToken) {
  let url = `${config.apiUrl}/user/oktaLogin`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${oktaToken}`,
    },
    body: JSON.stringify(requestBody),
  });

  const data = await response.json();
  return data;
}

async function azureAdLogin(microsoftAccessToken, email, keepMeSignedIn) {
  let url = `/user/azureAdLogin`;

  const config = {
    headers: {
      'Authorization': `Bearer ${microsoftAccessToken}`
    }
  };

  return http
    .post(
      url,
      JSON.stringify({
        email,
        keepMeSignedIn,
      }),
      config
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
}

function recoverPassword(email) {
  let url = `/user/recoverpassword`;

  return http
    .post(
      url,
      JSON.stringify({
        email,
      })
    )
    .then((response) => {
      return response;
    });
}

function validateCode(email, code) {
  let url = `/user/validatecode`;

  return http
    .post(
      url,
      JSON.stringify({
        email,
        code,
      })
    )
    .then((response) => {
      return response;
    });
}

function updatePassword(token, newPassword) {
  let url = `/user/updatepassword`;
  let config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return http
    .patch(
      url,
      JSON.stringify({
        newPassword,
      }),
      config
    )
    .then((response) => {
      return response;
    });
}

function create(
  token,
  firstName,
  lastName,
  email,
  clientId,
  clientGuid,
  password
) {
  let url = `/user/create`;
  let config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  return http
    .post(
      url,
      JSON.stringify({
        firstName,
        lastName,
        email,
        clientId,
        clientGuid,
        password,
      }),
      config
    )
    .then((response) => {
      return response;
    });
}

async function get(requestParameters) {
  let url = `/user?${Utils.objectToQueryString(requestParameters)}`;

  return await http.get(url).then((response) => {
    return response;
  });
}

async function getById(requestParameters) {
  // Support both old format (just userId string) and new format (object with userId, clientId, clientGuid)
  const params = typeof requestParameters === 'string'
    ? { userId: requestParameters }
    : requestParameters;

  let url = `/user/byid?${Utils.objectToQueryString(params)}`;

  return await http.get(url).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function update(requestBody) {
  let url = `/user/update`;

  return await http.patch(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function remove(requestParameters) {
  let url = `/user/delete?${Utils.objectToQueryString(requestParameters)}`;

  return await http.delete(url).then((response) => {
    return response;
  });
}

async function impersonate(userId) {
  let url = `/user/impersonate`;

  return await http.post(url, JSON.stringify({ userId })).then((response) => {
    return response;
  });
}

async function stopImpersonation(originalUserId, originalClientId, originalClientGuid, originalClientName) {
  let url = `/user/stopimpersonation`;

  return await http.post(url, JSON.stringify({
    originalUserId,
    originalClientId,
    originalClientGuid,
    originalClientName
  })).then((response) => {
    return response;
  });
}

async function getMcpRedirectUrl(returnTo, state) {
  return http
    .post("/user/mcp-redirect", JSON.stringify({ returnTo, state }))
    .then((response) => response);
}

async function refreshCurrentUser(userId, clientId, clientGuid) {
  let url = `/user/byid?${Utils.objectToQueryString({
    userId,
    clientId,
    clientGuid
  })}`;

  return await http.get(url).then((response) => {
    return response;
  });
}
